import React from 'react'
import { useHistory } from 'react-router-dom'

import { BROADCAST_WHITEBOARD_DATA, END_CALL } from 'constants/socket'
import { userTypes } from 'constants/user'
import { classStore } from 'helpers/room'
import { VIDEO_CALL } from 'services/webSockets/roomState/constants'
import { dispatchRoomState, dispatchSendSocketMessage } from 'store/dispatcher'
import { isDesktop } from 'utils/device'
import { logger } from 'utils/logger'

import useVideoContext from '../../../hooks/useVideoContext/useVideoContext'
import { MenuIcon, EndCallButtonStyle } from '../styles'
import StyledTooltip from '../TooltipWrapper'

const EndCallButton = () => {
    const { room, userType } = useVideoContext()
    const history = useHistory()

    const isTeacher = userType === userTypes.TEACHER

    const endCall = () => {
        if (isTeacher) {
            dispatchSendSocketMessage({
                action: BROADCAST_WHITEBOARD_DATA,
                data: END_CALL,
            })
            dispatchRoomState(VIDEO_CALL)
        }
        classStore.set('off')
        localStorage.setItem('refresh', 'false')
        let arr = ['']
        localStorage.setItem('canvaslist', JSON.stringify(arr))
        room.disconnect()
        logger.info('User has ended the call.')
        history && history.push('/feedback')
    }

    console.count('EndCallButton Component')

    const icon = isDesktop ? 'endCall' : 'endCall-mobile'

    return (
        <StyledTooltip
            title={'end call'}
            onClick={endCall}
            placement="left"
            arrow
            PopperProps={{ disablePortal: true }}
        >
            <EndCallButtonStyle>
                <MenuIcon
                    src={`/assets/controls/latest/${icon}.svg`}
                    alt="menu"
                />
            </EndCallButtonStyle>
        </StyledTooltip>
    )
}

export default EndCallButton
